import { OverlayModule } from "@angular/cdk/overlay";
import { NgModule } from "@angular/core";
import { AIOverlayControlDirective } from "./overlay-control.directive";
import { AIOverlayTriggerDirective } from "./overlay-trigger.directive";
import { AIOverlayComponent } from "./overlay.component";

@NgModule({
    imports: [OverlayModule],
    exports: [
        AIOverlayControlDirective,
        AIOverlayTriggerDirective,
        AIOverlayComponent,
    ],
    declarations: [
        AIOverlayControlDirective,
        AIOverlayTriggerDirective,
        AIOverlayComponent,
    ],
})
export class AIOverlayModule { }
